<template>
  <v-flex xs12 class="product-item">
    <promote-modal
      v-if="showPromoteMessage"
      :item="product"
      :dismiss="dismissPromoteModal"
      :success="saveAndFinish"
    ></promote-modal>

    <v-flex sm12 product-content-section pa-0 relative>
      <div
        class="product-image"
        :style="{
          'background-image': 'url(' + product.covers[0].cover.thumb.url + ')',
        }"
      ></div>
      <v-layout wrap row class="product-content">
        <v-flex xs12 sm6 class="product-content-row d-flex flex-column gap-4" pr-0>
          <label class="text-poppins-15">{{ product.name }}</label>

          <div>
            <label class="product-category-text" v-if="status && status != ''">
                {{ status }}
              </label>
              <label class="product-category-text">
                Category: {{ product.category ? product.category.name : "" }}
              </label>
              <label class="product-count product-sold-count">
                Sold: {{ product.sold }}
              </label>
              <label
                class="product-count product-status"
                v-if="product.stock_status == 'active'"
              >
                {{ product.stock_status }}
                <v-icon :class="product.stock_status">done</v-icon>
              </label>
              <label class="product-count product-status" v-else>
                {{ product.stock_status }}
                <v-icon :class="product.stock_status">done</v-icon>
              </label>
              
              <!-- <label class="product-count product-stock-count">
                In Stock: {{ product.stock }}
              </label> -->
          </div>
        </v-flex>
        <v-flex xs12 sm6 class="product-content-row d-flex align-center justify-end gap-15">
          <!-- <label class="product-price"
            >${{ product.price | formatNumber }}</label
          > -->

          <template v-if="$store.state.auth.user.id == product.merchant.id">
        
            <!-- <label class="btn-divider"></label>
            <v-btn class="text-btn" @click.native="showPromoteModal()" v-if="showPromoteButton">Promote</v-btn> -->
            <v-select
              :items="access_levels"
              v-model="access_level"
              item-text="title"
              item-value="id"
              placeholder="Select access level"
              class="pt-0 access-level"
              hide-details
              single-line
              @change="toggle_product_access_level_dialog = true"
            />

            <v-btn class="text-btn text-poppins-15" @click.native="editProduct()">Edit</v-btn>
            <v-btn
              class="text-btn text-poppins-15"
              @click.native.stop="deleteItem(product)"
              >Delete</v-btn
            >
          </template>
          <template v-else>
            <v-btn
              class="text-btn text-poppins-15"
              v-if="denyItem"
              @click.native="denyItem(product)"
              >Deny</v-btn
            >
            <label class="btn-divider" v-if="denyItem"></label>
            <v-btn
              class="text-btn text-poppins-15"
              v-if="acceptItem"
              @click.native="acceptItem(product)"
              >Accept</v-btn
            >
            <label class="btn-divider" v-if="acceptItem"></label>
          </template>
        </v-flex>
      </v-layout>
    </v-flex>

    <div 
      v-if="album.status == 'collaborated' || album.status == 'pending'"
      class="divider"
    ></div>


    <v-flex
      v-if="product.collaborators.length > 0"
      sm12
      collaborator-content-section
    >
      <div>
        <div class="text-poppins-14">Collaborators ({{ product.collaborators.length }})</div>
        <div class="collaborator-content">
          <div v-for="(collaborator, i) in product.collaborators" :key="i" class="collaborator-content__item">
            <img :src="collaborator.user.avatar.url" class="collaborator-content__item--img" />
            <div class="collaborator-content__item__user">
              <span class="username ">
                {{ collaborator.user.username }}
                <span 
                  v-if="
                    $store.state.auth.user.username === collaborator.user.username
                  "
                  >
                  (owner)
                </span>
              </span>
            <span class="user-type">{{ collaborator.user.user_type }}</span>
            </div>
          </div>
          <div
            v-if="product.status == 'pending'"
          >
            <v-btn
              v-if="currentUserOwnsProduct && allCollaboratedAccepted"
              depressed
              class="action-btn release"
              @click.native="releaseButtonAction(product)"
              >
                <span class="white--text">Release Now</span>
            </v-btn>
            <v-btn
              v-if="currentUserOwnsProduct && !allCollaboratedAccepted"
              depressed
              class="action-btn pending"
              disabled
              >
                <span>Pending</span>
              </v-btn>
  
              <div v-if="isUserCollaborator" class="dflex collaborator-action">
                <v-btn
                  class="text-btn"
                  :disabled="allCollaboratedAccepted"
                  @click.native="acceptCollaboration(product)"
                >
                  Accept
                </v-btn>
                <v-btn
                  class="text-btn"
                  :disabled="allCollaboratedAccepted"
                  @click.native="denyCollaboration(product)"
                >
                  Deny
                </v-btn>
            </div>
          </div>

        </div>
      </div>
    </v-flex>

    <v-dialog
      v-model="toggle_product_access_level_dialog"
      content-class="invite-dialog"
      width="440"
    >
      <v-card>
        <v-card-title class="headline">
          Update Access Level
        </v-card-title>
        <v-card-text>
          Are you sure you want to update the access level?
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" dark block @click.native="updateAccessLevel()"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script type="text/javascript">
/* global $:true */
import ProductService from '@/services/product'
import promoteModal from "@/components/promotemodal";
import UserService from '@/services/user';

export default {
  components: {
    promoteModal,
  },

  props: {
    product: {
      type: Object,
    },

    index: {
      type: Number,
    },

    acceptItem: {
      type: Function,
    },

    denyItem: {
      type: Function,
    },

    deleteItem: {
      type: Function,
    },

    status: {
      type: String,
    },

    showPromoteButton: {
      type: Boolean,
      default: true,
    },

    updateAccessLevelAction: {
      type: Function,
    },
  },

  data() {
    return {
      showPromoteMessage: false,
      dialog: false,
      access_levels: [],
      access_level: this.product.access_level,
      toggle_product_access_level_dialog: false,
    };
  },

  computed: {
    count() {
      var count = 0;
      for (let index in this.product.variants) {
        const variant = this.product.variants[index];
        count += variant.quantity;
      }
      return count;
    },
    currentUser() {
      return this.$store.state.auth.user
    },
    currentUserOwnsProduct() {
      return this.currentUser.id === this.product.merchant.id
    },
    isUserCollaborator() {
      const collaborators = this.product.collaborators
      const isCollaborator = collaborators.find(user => user.user_id === this.currentUser.id)
      return !!isCollaborator
    },
    collaborationData() {
      if (!this.isUserCollaborator) return null

      const collaborators = this.product.collaborators
      const collaboration = collaborators.find(user => user.user_id === this.currentUser.id)
      return collaboration
    },
    allCollaboratedAccepted() {
      const collaborations = this.product.collaborators
      const allAccepted = collaborations.every(collab => collab.status === "accepted")
      return allAccepted
    },
  },

  created() {},

  methods: {
    releaseButtonAction() {
      this.$emit("releaseButtonAction", this.product)
    },
    acceptCollaboration() {
      this.$emit("acceptCollaboration", this.product)
    },
    denyCollaboration() {
      this.$emit("denyCollaboration", this.product)
    },
    editProduct() {
      this.$router.push({ path: "/product/edit/" + this.product.id });
    },

    showPromoteModal() {
      this.showPromoteMessage = true;
      $("body").css("overflow", "scroll");
    },

    dismissPromoteModal() {
      this.showPromoteMessage = false;
      $("body").css("overflow", "scroll");
    },

    saveAndFinish(users) {
      $("body").css("overflow", "scroll");
      this.showPromoteMessage = false;
    },

    openAccessLevelConfirmDialog(product) {
      this.product = product
      this.toggle_product_access_level_dialog = true
    },

    closeAccessLevelConfirmDialog() {
      this.toggle_product_access_level_dialog = false
    },

    updateAccessLevel() {
      ProductService.updateAccessLevel(this.product.id, { access_level: this.access_level })
        .then((response) => {
          this.closeAccessLevelConfirmDialog()
          this.$store.dispatch('error/showSuccessToast', [
            'Access level updated successfully',
          ])
        })
        .catch((e) => {
          this.closeAccessLevelConfirmDialog()
          this.$store.dispatch(
            'error/showErrorToast',
            e.body.errors || [e.body]
          )
        })
    },
  },

  mounted() {
    UserService.getAccessLevels(this.product.merchant.id)
      .then((response) => {
        this.access_levels = response.body
        this.access_level = this.product.access_level
      });
  },
};
</script>

<style lang="scss" scoped>
.access-level {
  /deep/.material-icons {
    color: #000 !important;
  }
  /deep/[disabled] {
    background-color: #fff !important;
  }
}
</style>



// WEBPACK FOOTER //
// productitem.vue?0cf59956